import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initSentry } from './lib/sentry';

// Initialise Sentry before mounting React so errors thrown during render
// are captured. No-op unless REACT_APP_SENTRY_DSN is set — see #681.
initSentry();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);